export default __webpack_public_path__ + "static/media/800.72641903.gif";